import avatar from "./assets/avatar.svg";

// Ask Ethos icon for the sign-in splash, shown white. The pulse comes from AuthProvider.
export const SplashMark = () => (
    <img src={avatar} alt="" style={{ width: "100%", height: "100%", filter: "brightness(0) invert(1)" }} />
);
